import { useQuery } from '@tanstack/react-query';
import { fetchFeed } from '../api/discover';
import { pointKey, type DeliveryPoint } from './useDeliveryPoint';

/**
 * Home rows for the delivery point: rail rows, cuisines, "What's on your mind?" and the area
 * (serviceable or not). Cached per ~110 m cell; shows the last data at once and refreshes behind.
 */
export function useHomeFeed(point: DeliveryPoint | null) {
  const query = useQuery({
    queryKey: ['feed', pointKey(point)],
    queryFn: () =>
      fetchFeed({ lat: (point as DeliveryPoint).lat, lng: (point as DeliveryPoint).lng }),
    enabled: point !== null,
    staleTime: 30_000,
    placeholderData: (previous) => previous,
  });
  const feed = query.data ?? null;
  const top = feed?.rows.find((row) => row.kind === 'top') ?? null;
  return {
    loading: query.isLoading,
    failed: query.isError && !feed,
    retry: () => void query.refetch(),
    refreshing: query.isFetching && !query.isLoading,
    feed,
    area: feed?.area ?? null,
    top,
    otherRows: (feed?.rows ?? []).filter((row) => row !== top && row.items.length > 0),
  };
}
